import request from 'superagent';
import config from '../config';

const data = (query) => {
  return new Promise((resolve, reject) => {
    request
    .get(`${config.serverUrl}/article`)
    .set('Content-Type', 'application/json')
    .query(`where=${JSON.stringify(query)}&sort="referenceDate DESC"&limit=${query.limit || 10}&skip=${query.skip || 0}`)
    .end(function(err, resp) {
      if (err) {
        return reject(err);
      }

      return resolve(resp.body);
    });
  });
};

module.exports = {
  data() {
    return data();
  },

  dataWithQuery(query = {}) {
    return data(query);
  }
};



// WEBPACK FOOTER //
// ./src/services/article.js